import moment from 'moment';
import axios from 'axios';
import { mapGetters } from 'vuex';
import { TIME } from '../const';
import EventBus from '../event-bus';


const lastSyncMixin = {
  data() {
    return {
      interval: undefined,
      timeAgo: null,
      timeLastSync: null,
      duration: {},
      totalHours: 0,
    };
  },
  mounted() {
    this.mountInterval();
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
  computed: {
    currentLang() {
      return this.$i18n.locale;
    },
  },
  methods: {
    calcSync(datetime) {
      if (datetime !== undefined) this.timeLastSync = datetime;
      let sync = moment() - moment(this.timeLastSync);
      if (sync < 0) sync = 0;
      const keys = Object.keys(TIME.MODULES.META).filter(item => item <= sync);
      const value = keys.sort((a, b) => b - a)[0];
      if (value) this.setTimeAgo(sync, keys, value);
    },
    mountInterval() {
      const self = this;
      this.interval = setInterval(() => self.calcSync(), TIME.BASE.QUARTERMINUTE);
    },
    getTime(value) {
      const time = moment.duration(value);
      this.duration = {
        minutes: time.minutes(),
        hours: time.hours(),
        days: time.days(),
        months: time.months(),
      };
      this.calcTotalHours();
    },
    getPlural(trans, data) {
      const value = data[trans.toLowerCase()];
      if (value === 1) return 0;

      if (trans === 'MONTHS') {
        if (value < 5) return 1;
        return 2;
      } else if (trans === 'DAYS') {
        return 1;
      }
      return 0;
    },
    setTimeAgo(sync, keys, value) {
      const trans = TIME.MODULES.META[value];
      this.getTime(sync);
      const plural = this.getPlural(trans, this.duration);
      this.timeAgo = this.$tc(`META.SYNC.${trans}`, plural, this.duration);
    },
    calcTotalHours() {
      this.totalHours = (24 * this.duration.days) + this.duration.hours;
    },
  },
  watch: {
    currentLang() {
      this.calcSync();
    },
  },
};

const computeOptionsMixin = {
  methods: {
    getOptions(raw, locale) {
      const options = Object.entries(raw).filter(i => i[0] !== 'DEFAULT');
      return options.map(i => [parseInt(i[0], 10), i[1], this.$t(`${locale}.${i[1]}`)]);
    },
  },
};

const remoteSync = {
  computed: {
    ...mapGetters(['appData', 'pushTick']),
  },
  created() {
    this.startEventBus();
  },
  destroyed() {
    this.stopEventBus();
  },
  methods: {
    startEventBus() {
      EventBus.$on('setnexttick', this.setNextTick);
    },
    stopEventBus() {
      EventBus.$off('setnexttick', this.setNextTick);
    },
    checkIfTimerTimePassed() {
      const minPushTime = process.env.PUSH_TIMER_TICK - process.env.PUSH_SEND_TIMER_LIMIT;
      return this.pushTick <= (moment().utc() + minPushTime);
    },
    extendTimerTime() {
      this.$store.dispatch('renewPushTick');
    },
    resetTimerTime() {
      this.$store.dispatch('resetPushTick');
    },
    setNextTick() {
      if (this.checkIfTimerTimePassed()) {
        this.sendSinglePushRequest(this.appData.uid, this.appData.did);
      }
      this.extendTimerTime();
    },
    setInitialTick() {
      this.sendLoginPushRequest(this.appData.uid);
      this.extendTimerTime();
    },
    async sendSinglePushRequest(uid, did) {
      try {
        await axios.post(this.$store.getters.api.remoteSinglePusher, { uid, did });
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
      }
    },
    async sendLoginPushRequest(uid) {
      try {
        await axios.post(this.$store.getters.api.remoteLoginPusher, { uid });
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
      }
    },
    save() {
      this.setNextTick();
    },
    loginPushRequest() {
      this.setInitialTick();
    },
  },
};

export { lastSyncMixin, computeOptionsMixin, remoteSync };



// WEBPACK FOOTER //
// ./src/mixins/index.js